import { ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { ModalController, NavController, PopoverController } from '@ionic/angular';
import { AccountPaymentFavoriteDTO, AccountPaymentFavoriteService, TypeEnum } from '@wlp/ui-bs-account-payment-favorite';
import { TransferService } from '@wlp/ui-bs-cashout';
import { UserInfoService } from '@wlp/ui-bs-login';
import { UserInfoProfile } from '@wlp/ui-bs-login/lib/dto/user-info-profile';
import { UiBsMyDataService } from '@wlp/ui-bs-my-data';
import { UiBsTranslateService } from '@wlp/ui-bs-translate';
import { of } from 'rxjs/internal/observable/of';
import { catchError, tap } from 'rxjs/operators';
import { LayoutConfigModel } from 'src/app/core/layout/models/layout-config.model';
import { LayoutConfigService } from 'src/app/core/layout/services/layout-config.service';
import { LoadingService } from 'src/app/core/layout/services/loading.service';
import { ModalAlertComponent } from 'src/app/views/themes/sentinel/modals/modal-alert/modal-alert.component';
import {
  ModalFavoriteTypeComponent,
} from 'src/app/views/themes/sentinel/modals/modal-favorite-type/modal-favorite-type.component';
import {
  PopoverFavoritesComponent,
} from 'src/app/views/themes/sentinel/modals/popover-favorites/popover-favorites.component';

import { ModalSearchBankComponent } from '../../../../../../modals/modal-search-bank/modal-search-bank.component';
import { ModalTransferOnUsComponent } from '../../../../../../modals/modal-transfer-on-us/modal-transfer-on-us.component';
import { FavoritesDataFilterPipe } from '../../favorites-data-filter.pipe';
import { environment } from './../../../../../../../../../../environments/environment';

@Component({
  selector: 'app-favorites-transfer',
  templateUrl: './favorites-transfer.page.html',
  styleUrls: ['./favorites-transfer.page.scss'],
  providers: [FavoritesDataFilterPipe],
})
export class FavoritesTransferPage implements OnInit, OnDestroy {

  private langDefault: string;
  private layoutConfigValue: LayoutConfigModel;
  private userProfile: UserInfoProfile;
  private onUsSelected: any;
  private bkName: string;
  public favorite: any;
  public backgroundHeader: any;
  public switchFavorites: string = 'favorites';
  public favoriteId: any;
  public listFavoritesShow: any;
  public listFavorites: any;
  public isUp: boolean = false;
  public formFavorite: FormGroup;
  public errorMessages: any;
  public selectedFavorite: boolean = false;
  public ownership: boolean = false;
  public isTED: boolean = true;
  public isOnUs: boolean = false;
  isTEF: boolean;

  constructor(
    protected userInfoService: UserInfoService,
    private layoutConfigService: LayoutConfigService,
    private modalController: ModalController,
    private myDataService: UiBsMyDataService,
    private navCtrl: NavController,
    private cdr: ChangeDetectorRef,
    private loadingService: LoadingService,
    public favoriteService: AccountPaymentFavoriteService,
    public transferService: TransferService,
    private translate: UiBsTranslateService,
    public pipeFilter: FavoritesDataFilterPipe,
    public popoverController: PopoverController,
  ) { }

  ngOnInit() {
    this.layoutConfigValue = this.layoutConfigService.getSavedConfig();
    this.langDefault = this.layoutConfigValue.wlTheme.languageDefault;
    this.translate.setDefaultLang(this.langDefault);
    this.backgroundHeader = this.layoutConfigService.getConfig('wlTheme.header.background.image');
    this.loadUser();
    this.formFavorite = this.favoriteService.createFormFavoriteTransfer();
    this.errorMessages = this.favoriteService.getFormMessageError();
    this.bkName = environment.wlThemeParameterization.wlTheme.wlName;
  }

  private loadUser() {
    this.userInfoService.getInfoProfile().then(
      (res) => {
        this.userProfile = res;
        if (this.userProfile) {
          this.getFavorites();
        }
      }
    );
  }

  private getFavorites() {
    this.loadingService.show();
    this.favoriteService.findFavoritesToTransfer(this.userProfile.uuidWhiteLabel, this.userProfile.uuidAccount)
      .pipe(
        tap((data) => {
          this.loadingService.hide();
          this.listFavorites = data;
          this.listFavoritesShow = this.favoriteService.sortFavoritesListByName(data);
        }),
        catchError((_) => {
          this.loadingService.hide();
          return of(null);
        })
      )
      .subscribe();
    this.loadingService.hide();
    this.cdr.detectChanges();
  }

  public goBack() {
    this.navCtrl.navigateRoot(['app/dashboard']);
  }

  public segmentChanged(favorite: string) {
    this.switchFavorites = favorite;
    if (favorite == 'favorites') {
      this.getFavorites();
      this.isOnUs = false;
      this.isTED = true;
      this.resetForm();
    }
    if (favorite == 'new' && !this.selectedFavorite) this.chooseType();
  }

  public sortList() {
    this.isUp = !this.isUp;
    this.listFavoritesShow = this.listFavoritesShow.reverse();
  }

  public filterFavorites(value: string) {
    if (value !== '') {
      this.listFavoritesShow = this.pipeFilter.transform(this.listFavorites, value);
    } else {
      this.getFavorites();
    }
  }

  public async chooseType() {
    this.isTED = true;
    this.isOnUs = false;
    const modalBank = await this.modalController.create({
      component: ModalFavoriteTypeComponent,
      cssClass: 'modal-favorite-type',
      componentProps: {
        bankName: this.bkName,
      }
    });
    modalBank.onDidDismiss().then((callback) => {
      if (callback['data']) {        
        switch (callback.data) {
          case "TED":
            this.isTED = true;
            this.isOnUs = false;
            this.isTEF = false;
            break;
          case "TEF":
            this.isTEF = true;
            this.isTED = false;
            this.isOnUs = false;
            break;

          case "ON-US":
            this.isTED = false;
            this.isTEF = false;
            this.isOnUs = true;
            break;          
        }
      } else {
        this.switchFavorites = 'favorites';
      }
    });
    return await modalBank.present();
  }

  public checkOnUs() {
    if (this.isOnUs && (!this.formFavorite.controls.document.invalid)) {
      this.loadingService.show();
      this.transferService
        .checkAccountSameBucket(this.userProfile.uuidWhiteLabel, this.formFavorite.get('document').value, this.userProfile.uuidAccount)
        .then((res) => {
          this.loadingService.hide();
          if (res && res.length > 0) {
            this.listAccontsOnUs(res);
          } else {
            this.statusNotification('warning-circle', 'FAVORITES.MESSAGES.ACCOUNT_NOT_FOUND', true);
          }
        })
        .catch((err) => {
          this.loadingService.hide();
          this.statusNotification('warning-circle', 'FAVORITES.MESSAGES.ACCOUNT_NOT_FOUND', true);
        });
    }
  }

  public async listAccontsOnUs(list: Array<any>) {
    this.loadingService.hide();
    const modal = await this.modalController.create({
      component: ModalTransferOnUsComponent,
      cssClass: 'modal-select-on-us',
      componentProps: {
        accountList: list,
        favorite: true
      },
      backdropDismiss: false,
    });
    modal.onDidDismiss().then((callback) => {
      if (!!callback.data) {
        this.onUsSelected = callback.data;
        this.formFavorite.setValue({
          document: this.formatCnpjCpf(callback.data.document),
          name: callback.data.name,
          accountType: 'PG',
          bank: callback.data.bankName,
          branch: callback.data.bankBranch,
          accountNumber: callback.data.bankAccount,
          bankCode: callback.data.codeBank,
        });
      } else {
        this.chooseType();
      }
    });
    return await modal.present();
  }

  public async editOrDelete(ev: any) {
    const popover = await this.popoverController.create({
      component: PopoverFavoritesComponent,
      cssClass: 'popover-class',
      event: ev.event,
      translucent: true,
      mode: 'md',
    });
    popover.onDidDismiss().then((data) => {
      if (data.data == 'exclude') {
        this.deleteFavorite(ev.favorite);
      }
      if (data.data == "edit") {
        this.editFavorite(ev.favorite);
      }
    });
    return await popover.present();
  }

  public deleteFavorite(favorite: any) {
    this.loadingService.show();
    this.favoriteService.deleteFavorite(favorite).pipe(
      tap((data) => {
        if (data.status) {
          this.resetForm();
          this.getFavorites();
          this.statusNotification('success', 'FAVORITES.MESSAGES.DELETE_SUCCESS', true);
          this.favoriteId = undefined;
          this.switchFavorites = 'favorites';
        } else {
          this.statusNotification('warning-circle', 'FAVORITES.MESSAGES.FAILED', true);
        }
        this.loadingService.hide();
      }),
      catchError((_) => {
        this.loadingService.hide();
        return null;
      }),
    ).subscribe();
  }

  public editFavorite(favorite: any) {
    this.favoriteId = favorite.id;
    this.favorite = favorite;

    this.formFavorite.setValue({
      document: this.formatCnpjCpf(favorite.document),
      name: favorite.name,
      accountType: favorite.typeAccount,
      bank: favorite.bankName,
      branch: favorite.agencyNumber,
      accountNumber: favorite.accountNumber,
      bankCode: favorite.codeBank ? favorite.codeBank : ''
    });

    this.selectedFavorite = true;
    this.switchFavorites = 'new';
    if (favorite.type == 'TED') {
      this.isTED = true;
      this.isOnUs = false;
      this.isTEF = false;
    }    
    if (favorite.type == 'TEF') {
      this.isTEF = true;
      this.isOnUs = false;
      this.isTED = false;
    }
    if (favorite.type == 'ON_US') {
      this.isTED = false;
      this.isTEF = false;
      this.isOnUs = true;
    }
  }

  public sameOwnership() {
    if (this.ownership === false) {
      this.ownership = true;
      this.myDataService.getPersonalData(this.userProfile.uuidAccount).subscribe(
        (res) => {
          this.formFavorite.controls.document.setValue(this.formatCnpjCpf(res.document));
          this.formFavorite.controls.name.setValue(res.name);
        },
        (error) => {
          console.error(error);
        }
      );
    } else {
      this.formFavorite.controls.document.setValue('');
      this.formFavorite.controls.name.setValue('');
      this.ownership = false;
      this.cdr.detectChanges();
    }
  }

  private formatCnpjCpf(value: string) {
    const document = value.replace(/\D/g, '');
    if (document.length === 11) {
      return document.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/g, '$1.$2.$3-$4');
    } else if (document.length > 11) {
      return document.replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/g, '$1.$2.$3/$4-$5');
    } else {
      return value;
    }
  }

  public async searchBank() {
    const modalBank = await this.modalController.create({
      component: ModalSearchBankComponent,
      cssClass: 'modal-search-bank',
    });
    modalBank.onDidDismiss().then((data) => {
      if (data['data']) {        
        this.formFavorite.controls.bank.setValue(data['data'].name);
        this.formFavorite.controls.bankCode.setValue(data['data'].code);
      }
    });
    return await modalBank.present();
  }

  public resetForm() {
    this.formFavorite = this.favoriteService.createFormFavoriteTransfer();
    this.favoriteId = null;
    this.switchFavorites = 'favorites';
    this.isTED = true;
    this.isOnUs = false;
    this.selectedFavorite = false;
  }

  public continue() {
    if (!!this.favoriteId && !!this.favorite.uuid) {
      this.favorite = {
        id: this.favoriteId,
        uuid: this.favorite.uuid,
        uuidWhiteLabel: this.userProfile.uuidWhiteLabel,
        uuidAccountPayment: this.userProfile.uuidAccount,
        uuidAccountPaymentDestination: this.favorite.uuidAccountPaymentDestination,
        uuidWhiteLabelDestination: this.favorite.uuidWhiteLabelDestination,
        name: this.formFavorite.controls.name.value,
        document: this.formFavorite.controls.document.value,
        typeAccount: this.formFavorite.controls.accountType.value,
        codeBank: this.formFavorite.controls.bankCode.value,
        bankName: this.formFavorite.controls.bank.value,
        agencyNumber: this.formFavorite.controls.branch.value,
        accountNumber: this.formFavorite.controls.accountNumber.value,
        type: this.favorite.type
      };
      this.updateFavorite(this.favorite);
    } else {
      let prepare: AccountPaymentFavoriteDTO = {
        uuidWhiteLabel: this.userProfile.uuidWhiteLabel,
        uuidAccountPayment: this.userProfile.uuidAccount,
        uuidAccountPaymentDestination: (this.isOnUs) ? this.onUsSelected.uuidAccountPayment : null,
        uuidWhiteLabelDestination: (this.isOnUs) ? this.onUsSelected.uuidWhiteLabel : null,
        name: this.formFavorite.controls.name.value,
        document: this.formFavorite.controls.document.value,
        typeAccount: this.formFavorite.controls.accountType.value,
        codeBank: this.formFavorite.controls.bankCode.value,
        bankName: this.formFavorite.controls.bank.value,
        agencyNumber: this.formFavorite.controls.branch.value,
        accountNumber: this.formFavorite.controls.accountNumber.value,
        type: this.checkTypeFavorite()
      };
      this.validateNewFavorite(prepare);
    }
  }

  checkTypeFavorite() {
    if(this.isTED) return TypeEnum.TED;
    if(this.isOnUs) return TypeEnum.ON_US;
    if(this.isTEF) return TypeEnum.TEF;    
  }

  private updateFavorite(favoriteBody: any) {
    this.loadingService.show();
    this.favoriteService.updateFavorite(favoriteBody).pipe(
      tap((data) => {
        if (data.status) {
          this.statusNotification('success', 'FAVORITES.MESSAGES.SAVE_SUCCESS', true);
          this.getFavorites();
          this.resetForm();
          this.favoriteId = undefined;
          this.switchFavorites = "favorites";
        } else {
          this.statusNotification('warning-circle', 'FAVORITES.MESSAGES.FAILED', true);
        }
        this.loadingService.hide();
      }),
      catchError((_) => {
        this.loadingService.hide();
        this.statusNotification('warning-circle', 'FAVORITES.MESSAGES.FAILED', true);
        return of(null);
      }),
    ).subscribe();
  }

  private validateNewFavorite(prepare: any) {
    let exist: boolean = false;
    this.listFavorites.map(el => {
      if ((!!el.uuidAccountPaymentDestination) && (el.uuidAccountPaymentDestination == prepare.uuidAccountPaymentDestination)) {
        exist = true;
      } else if (
        (el.codeBank == prepare.codeBank) &&
        (el.agencyNumber == prepare.agencyNumber) &&
        (el.accountNumber.replace(/[^\w\s]/gi, '') == prepare.accountNumber.replace(/[^\w\s]/gi, '')) &&
        (el.document.replace(/[^\w\s]/gi, '') == prepare.document.replace(/[^\w\s]/gi, ''))
      ) {
        exist = true;
      }
    });
    if (exist) {
      this.statusNotification('warning-circle', 'FAVORITES.MESSAGES.FAILED_ALREADY_EXISTS', true);
    } else {
      this.saveFavorite(prepare);
    }
  }

  private saveFavorite(favoriteBody: any) {
    this.favoriteService.saveFavorite(favoriteBody).pipe(
      tap((data) => {
        if (data.status) {
          this.statusNotification('success', 'FAVORITES.MESSAGES.SAVE_SUCCESS', true);
          this.resetForm();
          this.getFavorites();
          this.favoriteId = undefined;
          this.switchFavorites = 'favorites'
        } else {
          this.statusNotification('warning-circle', 'FAVORITES.MESSAGES.FAILED', true);
        }
        this.loadingService.hide();
      }),
      catchError((_) => {
        this.loadingService.hide();
        this.statusNotification('warning-circle', 'FAVORITES.MESSAGES.FAILED', true);
        return of(null);
      }),
    ).subscribe();
  }

  private async statusNotification(status: string, message: string, translateFlag: boolean) {
    this.loadingService.hide();
    const translate = translateFlag ? true : false;
    const modalStatus = await this.modalController.create({
      component: ModalAlertComponent,
      cssClass: 'modal-alert-class',
      componentProps: {
        status: status,
        message: message,
        confirmBtn: 'FAVORITES.BUTTONS.CLOSE',
        translate: translate,
      },
      backdropDismiss: false,
    });
    return await modalStatus.present();
  }

  ngOnDestroy() {
    this.resetForm();
  }
}
